// TimeItem Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactDom from 'react-dom'
import classnames from 'classnames'
import _ from 'lodash'

import Util from '../../../lib/util.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import ProgressBar from '../../../common/common/progress_bar/progress_bar.jsx'
import Input from '../../../common/form/input/input.jsx'
import WysiwygEditor from '../../../common/form/wysiwyg_editor/wysiwyg_editor.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import TimeClock from '../time_clock/time_clock.jsx'
import ConfirmDelete from '../../../common/common/confirm_delete/confirm_delete.jsx'
import timerStates from '../../../../shared/util/timer/timerStates.js'

class TimeItem extends Component {
  constructor (props) {
    super(props)

    this.state = {
      timeTakenText: this._formatTimeForInput(props.time.timeTaken),
      showConfirm: false,
      dataDate: null,
      autoFocus: this.props.active
    }

    this._references = {
      timeInput: React.createRef(),
      confirmTimeDelete: React.createRef()
    }

    this._saveTime = null
  }

  static get propTypes () {
    return {
      time: PropTypes.object,
      active: PropTypes.bool,
      inActive: PropTypes.bool,
      canEdit: PropTypes.bool,
      canStartTimer: PropTypes.bool,
      timer: PropTypes.object.isRequired,
      onSave: PropTypes.func,
      onDelete: PropTypes.func,
      onCloseForm: PropTypes.func,
      onOpenForm: PropTypes.func,
      onTimerStart: PropTypes.func,
      onTimerPause: PropTypes.func,
      onTimerFinalize: PropTypes.func,
      onShowDetailForm: PropTypes.func,
      onUpdateFavorite: PropTypes.func,
      onTimerStop: PropTypes.func,
      stopAndCreateNewTimeCard: PropTypes.func,
      onShowError: PropTypes.func,
      remainingMins: PropTypes.number
    }
  }

  static get defaultProps () {
    return {
      time: null,
      active: false,
      inActive: false,
      canEdit: true,
      canStartTimer: false,
      onSave: null,
      onDelete: null,
      onCloseForm: null,
      onOpenForm: null,
      onTimerStart: null,
      onTimerPause: null,
      onTimerFinalize: null,
      onShowDetailForm: null,
      onUpdateFavorite: null,
      onTimerStop: null,
      stopAndCreateNewTimeCard: null,
      onShowError: null,
      remainingMins: 0
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    if (
      nextProps.active !== undefined &&
      this.props.active !== nextProps.active
    ) {
      const stateObj = { active: nextProps.active }
      if (
        nextProps.time &&
        this.props.time &&
        nextProps.time.timeTaken !== this.props.time.timeTaken
      ) {
        stateObj.timeTakenText = nextProps.time
          ? this._formatTimeForInput(nextProps.time.timeTaken)
          : ''
      }

      this.setState(stateObj)
    } else if (
      !this.props.active &&
      nextProps.time.timeTaken !== this.props.time.timeTaken
    ) {
      // Update time only if timecard not in edit mode
      const timeTakenText = this._formatTimeForInput(nextProps.time.timeTaken)
      this.setState({ timeTakenText: timeTakenText })
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (
      this._references.timeInput.current &&
      this.state.active &&
      prevState.active !== this.state.active
    ) {
      this._references.timeInput.current.focus()
    }
  }

  componentDidMount () {
    window.rootApp.addEventListener('click', this._handleDocumentClick)
  }

  componentWillUnmount () {
    window.rootApp.removeEventListener('click', this._handleDocumentClick)
  }

  render () {
    const time = this.props.time
    const inProgress = this._isTimerActive()
    const bStarted = this._isTimerStarted()
    const bClosed = time.project && time.project.status === 'closed'
    const bCompleted = time.project && time.project.status === 'completed'
    const canEdit = this.props.canEdit && !bClosed && !bCompleted
    const canChangeDescription = !bClosed && !bCompleted
    const canStartTimer =
      this.props.canStartTimer &&
      !bClosed &&
      !bCompleted &&
      time.timeTaken < 1440 // 24 hours - 24 * 60

    const _className = classnames('time-item', {
      active: this.props.active,
      inactive: this.props.inActive,
      inprogress: inProgress,
      started: bStarted,
      closed: bClosed || bCompleted,
      disableedit: !canEdit,
      hasnotimer: !canStartTimer
    })

    const timeOptions = [
      {
        label: 'time.item.labelFifteenMinutes',
        title: 'time.item.titleAdd15Minutes',
        value: 15
      },
      {
        label: 'time.item.labelThirtyMinutes',
        title: 'time.item.titleAdd30Minutes',
        value: 30
      },
      {
        label: 'time.item.labelOneHour',
        title: 'time.item.titleAddOneHour',
        value: 60
      },
      {
        label: 'time.item.labelTwoHour',
        title: 'time.item.titleAddTwoHour',
        value: 120
      },
      {
        label: 'time.item.labelFourHours',
        title: 'time.item.titleAddFourHours',
        value: 240
      },
      {
        label: 'time.item.labelEightHours',
        title: 'time.item.titleAddEightHours',
        value: 480
      }
    ]
    const activityOptions = [
      { label: 'time.item.activityHoliday', value: 'Holiday' },
      { label: 'time.item.activitySickLeave', value: 'SickLeave' },
      { label: 'time.item.activityMeeting', value: 'Meeting' },
      { label: 'time.item.activityTraining', value: 'Training' },
      { label: 'time.item.activityDoctorOrDentist', value: 'Doctor/Dentist' },
      { label: 'time.item.activityOther', value: 'Other' }
    ]
    let timeLeft = null
    let percentageCompleted = 0

    if (time.activityItem) {
      percentageCompleted = time.activityItem.percentage
    }
    timeLeft = this._convertMinutesToHour(timeLeft)

    const absentActivities = [
      'Holiday',
      'SickLeave',
      'Meeting',
      'Training',
      'Doctor/Dentist',
      'Other'
    ]
    const bNormalActivity =
      _.findIndex(absentActivities, act => act === time.activity) >= 0
    const activityIdent = _.find(
      activityOptions,
      activityOption => activityOption.value === time.activity
    )
    const timeClassName = `time${!canStartTimer ? ' time_alt' : ''}`

    const timeTakenText = this.state.timeTakenText
    const pattern = /[^:0-9]/gi
    const timeTaken = timeTakenText.replace(pattern, '')

    return (
      <div className={_className}>
        <div className='cont'>
          <div
            className='timeheader'
            onClick={canEdit ? this._onClickItem.bind(this) : null}
          >
            <div className='action'>
              {!bStarted && !bNormalActivity && canStartTimer && (
                <IconButton
                  icon='time-timerstart'
                  size='normal'
                  className='timerstart'
                  onClick={this._onTimerStart.bind(this)}
                  canHover={false}
                />
              )}
              {bStarted && canStartTimer && (
                <IconButton
                  icon='time-timerstop'
                  size='normal'
                  className='timerstop'
                  onClick={this._onTimerPause.bind(this)}
                  canHover={false}
                />
              )}
              {canEdit && (
                <IconButton
                  icon={
                    time.isFavorite
                      ? 'time-ratingstar-hover'
                      : 'time-ratingstar'
                  }
                  size='normal'
                  canHover={!time.isFavorite}
                  tooltip='time.item.addFavourite'
                  tooltipPosition='right'
                  className={`time${time.isFavorite ? ' time_favourite' : ''}${
                    bNormalActivity ? ' time_show' : ''
                  }`}
                  onClick={this._onChangeFavourite.bind(this)}
                />
              )}
              {bStarted ? (
                <TimeClock
                  type='timeCard'
                  timer={this.props.timer}
                  timeSpent={time.timeTaken}
                  stopAndCreateNewTimeCard={this._stopAndCreateNewTimeCard.bind(
                    this
                  )}
                />
              ) : (
                <Input
                  type='text'
                  name='time'
                  label='time.item.labelTimeInput'
                  className={timeClassName}
                  value={timeTaken}
                  size={10}
                  maxLength={100}
                  validations={['required']}
                  ref={this._references.timeInput}
                  readOnly={bStarted || !canEdit}
                  onChange={this._onChangeTimeTaken.bind(this)}
                  onBlur={this._onBlurTimeTaken.bind(this)}
                  autoFocus={this.state.autoFocus}
                />
              )}
              {bStarted && canStartTimer && (
                <IconButton
                  icon='common-success-tick'
                  size='normal'
                  className='timersave'
                  onClick={this._onTimerFinalize.bind(this)}
                  canHover={false}
                />
              )}
              {canEdit && (
                <IconButton
                  icon='common-item-delete'
                  size='normal'
                  className='purchaseview'
                  onClick={this._onDelete.bind(this)}
                  canHover={false}
                />
              )}
            </div>
            <span className='info'>
              <IntlMessage ident='time.item.labelHours' />
            </span>
          </div>
          {canEdit && (
            <div className='timebuttons'>
              {timeOptions.map((timeOpt, idx) => (
                <div
                  title={IntlUtil.convertMessage(timeOpt.title)}
                  key={idx}
                  onClick={this._onIncrementTime.bind(this, timeOpt.value)}
                  className='timebutton'
                >
                  <IntlMessage ident={timeOpt.label} />
                </div>
              ))}
            </div>
          )}
          {canChangeDescription && (
            <div className='timedesc form'>
              <WysiwygEditor
                placeholder='time.item.labelDescription'
                value={time.description}
                onBlur={this._onChangeDescription.bind(this)}
                inlineEditor
              />
            </div>
          )}
          <div className='progress'>
            <ProgressBar
              value={percentageCompleted}
              mode='determinate'
              max={100}
              buffer={100}
              type='linear'
              formatOverdue
            />
          </div>
          {bNormalActivity ? (
            <div className='itemcont normal'>
              <h2 className='project'>
                <IntlMessage ident={activityIdent.label} />
              </h2>
            </div>
          ) : (
            <div
              className='itemcont'
              onClick={canEdit ? this._onClickTask.bind(this) : null}
            >
              {bClosed ? (
                <span className='prjclosed'>
                  <IntlMessage ident='time.item.projectClosed' />
                </span>
              ) : (
                bCompleted && (
                  <span className='prjclosed'>
                    <IntlMessage ident='time.item.projectCompleted' />
                  </span>
                )
              )}
              {time.task && time.task.title && (
                <span className='client'>{time.task.title}</span>
              )}
              {time.task && time.task.title && <div className='split' />}
              <span className='client'>
                {time.project && time.project.contact ? (
                  time.project.contact.company
                ) : (
                  <IntlMessage ident='time.item.client' />
                )}
              </span>
              <h2 className='project'>
                {time.project ? (
                  time.project.title
                ) : (
                  <IntlMessage ident='time.item.project' />
                )}
              </h2>
              <div className='split' />
              <span className='hour'>
                {time.activity ? (
                  time.activity
                ) : (
                  <IntlMessage ident='time.item.activity' />
                )}
              </span>
              <span className='hour'>
                {timeLeft !== null ? (
                  timeLeft
                ) : (
                  <IntlMessage ident='time.item.timeleft' />
                )}
              </span>
            </div>
          )}
        </div>
        <ConfirmDelete
          ref={this._references.confirmTimeDelete}
          title='time.list.msgDelete'
          onClickOk={this._onClickDeleteConfirm.bind(this)}
        />
      </div>
    )
  }

  /* Event Handlers */
  _handleDocumentClick = evt => {
    if (this.state.showConfirm) {
      if (this._references.confirmTimeDelete.current) {
        this._references.confirmTimeDelete.current.hide()
      }
    }

    if (this.props.active) {
      const area = ReactDom.findDOMNode(this)
      if (!area.contains(evt.target)) {
        if (this.props.onCloseForm) {
          this.props.onCloseForm()
        }
      }
    }
  }

  _onClickDeleteConfirm (ev) {
    ev.preventDefault()

    if (this.props.onDelete) {
      this.props.onDelete(this.props.time.id)
    }
  }

  _convertMinutesToHour (value) {
    if (value && value > 0) {
      const hours = Math.floor(value / 60)
      const mins = Math.floor(value % 60)

      return `${hours} hours ${mins} mins left`
    }

    return ''
  }

  _onTimerStart (ev) {
    ev.preventDefault()
    ev.stopPropagation()

    if (this.props.onTimerStart) {
      this.props.onTimerStart(this.props.time)
    }
  }

  _onTimerPause (ev) {
    ev.preventDefault()
    ev.stopPropagation()

    if (this.props.onTimerPause) {
      this.props.onTimerPause(this.props.time)
    }
  }

  _onTimerFinalize (ev) {
    ev.preventDefault()
    ev.stopPropagation()

    if (this.props.onTimerFinalize) {
      this.props.onTimerFinalize(this.props.time)
    }
  }

  _onTimeStop () {
    if (this.props.onTimerStop) {
      this.props.onTimerStop(this.props.time)
    }
  }

  _stopAndCreateNewTimeCard () {
    if (this.props.stopAndCreateNewTimeCard) {
      this.props.stopAndCreateNewTimeCard(this.props.time)
    }
  }

  _onClickItem () {
    // If no timer running, show manuall time update form
    if (!this._isTimerStarted()) {
      if (this.props.onOpenForm) {
        this.props.onOpenForm(this.props.time.id)
      }
    } else {
      // If has active timer, show the details form
      if (this.props.onShowDetailForm) {
        this.props.onShowDetailForm(this.props.time)
      }
    }
  }

  _onClickTask () {
    if (this.props.onShowDetailForm) {
      this.props.onShowDetailForm(this.props.time)
    }
  }

  _onIncrementTime (incrValue) {
    const { remainingMins, onShowError } = this.props

    if (remainingMins < this.props.time.timeTaken + incrValue) {
      if (onShowError) {
        onShowError()
      }
    } else {
      const incrementFn = _.debounce(
        this._updateTimeTakenValue.bind(this, incrValue),
        1000
      )
      incrementFn()
    }
  }

  _updateTimeTakenValue (incrValue) {
    const newTimeTaken = this._updateTimeTaken(
      this.props.time.timeTaken + incrValue
    )
    this.setState({ timeTakenText: this._formatTimeForInput(newTimeTaken) })
  }

  _onChangeDescription (description) {
    this.props.onSave(this.props.time.id, { description: description })
  }

  _onChangeTimeTaken (value) {
    const { remainingMins, onShowError } = this.props

    if (!/^[0-9]{0,2}(:)*[0-9]{0,2}$/.test(value)) {
      this.forceUpdate()
    } else {
      let timeTaken = 0
      const timeArr = value.split(':')
      if (timeArr.length > 1) {
        timeTaken =
          (timeArr[0] ? parseInt(timeArr[0], 10) : 0) * 60 +
          (timeArr[1] ? parseInt(timeArr[1], 10) : 0)
      } else {
        timeTaken = parseInt(timeArr[0], 10) * 60
      }

      if (remainingMins < timeTaken) {
        if (onShowError) {
          onShowError()
        }
      } else {
        const newTimeTaken = this._updateTimeTaken(timeTaken)
        if (newTimeTaken !== timeTaken) {
          this.setState({
            timeTakenText: this._formatTimeForInput(newTimeTaken)
          })
        } else {
          this.setState({ timeTakenText: value })
        }
      }
    }
  }

  _onBlurTimeTaken () {
    this.setState({
      timeTakenText: this._formatTimeForInput(this.props.time.timeTaken),
      autoFocus: false
    })
  }

  _onDelete (ev) {
    ev.preventDefault()
    ev.stopPropagation()

    this.setState({ showConfirm: true, dataDate: new Date() })

    if (this._references.confirmTimeDelete.current) {
      this._references.confirmTimeDelete.current.show()
    }
  }

  _onChangeFavourite (ev) {
    ev.preventDefault()
    ev.stopPropagation()

    const timeObj = this.props.time
    timeObj.isFavorite = !timeObj.isFavorite
    this.props.onUpdateFavorite(timeObj, timeObj.isFavorite)
  }

  _updateTimeTaken (timeTaken) {
    timeTaken = timeTaken > 24 * 60 ? 24 * 60 : timeTaken
    const timeObj = this.props.time
    timeObj.timeTaken = timeTaken

    if (this._saveTime) window.clearTimeout(this._saveTime)

    this._saveTime = window.setTimeout(() => {
      this.props.onSave(timeObj.id, { timeTaken: timeTaken || 0 })
    }, 1000)

    return timeTaken
  }

  _formatTimeForInput (timeTaken) {
    return timeTaken ? Util.convertMinutesToHour(timeTaken) : ''
  }

  _getStatus () {
    const { timer } = this.props

    return timer.doesRelateToTimeCardId(this.props.time.id) ? timer.Status() : ''
  }

  _isTimerStarted () {
    return this._getStatus() === timerStates.STARTED
  }

  _isTimerActive () {
    const status = this._getStatus()
    return [timerStates.STARTED, timerStates.PAUSED].includes(status)
  }
}

export default TimeItem
